import script from "./FeatherIcon.vue?vue&type=script&lang=js"
export * from "./FeatherIcon.vue?vue&type=script&lang=js"

import "./FeatherIcon.vue?vue&type=style&index=0&id=bd5207b0&lang=scss"

const __exports__ = script;

export default __exports__